import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { guides } from '../data/admissionData';
import { glossaryMeta, glossaryTerms } from '../data/glossaryTerms';
import '../styles/Glossary.css';

const guideTitle = Object.fromEntries(guides.map((g) => [g.id, g.title]));

const Glossary = () => {
  const [q, setQ] = useState('');

  const filtered = useMemo(() => {
    const needle = q.trim().toLowerCase();
    if (!needle) return glossaryTerms;
    return glossaryTerms.filter(
      (t) =>
        t.ja.toLowerCase().includes(needle) ||
        t.ko.toLowerCase().includes(needle) ||
        t.def.toLowerCase().includes(needle)
    );
  }, [q]);

  return (
    <div className="apple-page apple-glossary">
      <header className="apple-page-hero">
        <p className="apple-eyebrow">Glossary</p>
        <h1 className="apple-display">{glossaryMeta.title}</h1>
        <p className="apple-lede">{glossaryMeta.lede}</p>
        <p className="apple-glossary-meta">업데이트 {glossaryMeta.updatedAt}</p>
      </header>

      <label className="apple-glossary-search">
        검색
        <input
          type="search"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="예: 필착, EJU, 検定料"
        />
      </label>

      <ul className="apple-glossary-list">
        {filtered.map((term) => (
          <li key={term.id} id={term.id}>
            <h2>
              <span className="apple-glossary-ko">{term.ko}</span>
              <span className="apple-glossary-ja">{term.ja}</span>
            </h2>
            <p>{term.def}</p>
            {term.guideIds?.length > 0 && (
              <p className="apple-glossary-links">
                {term.guideIds.map((gid, i) => (
                  <React.Fragment key={gid}>
                    {i > 0 ? ' · ' : null}
                    <Link to={`/guides/${gid}`}>{guideTitle[gid] || gid}</Link>
                  </React.Fragment>
                ))}
              </p>
            )}
          </li>
        ))}
      </ul>

      {filtered.length === 0 && (
        <p className="apple-empty">검색 결과가 없습니다.</p>
      )}

      <div className="apple-page-foot">
        <Link to="/checklist" className="apple-btn apple-btn-primary">
          요강 체크리스트
        </Link>
        <Link to="/guides" className="apple-link">
          가이드
        </Link>
      </div>
    </div>
  );
};

export default Glossary;
